/**
 * GitHub Copilot config writer
 *
 * Skill: ~/.agents/skills/sailfish-autofix/ (cross-client)
 * MCP: ~/.vscode/mcp.json servers.sailfishAutofix
 */

import { homedir } from "os";
import { join } from "path";
import type { AgentConfigWriter } from "./base.js";
import { installCrossClientSkill, removeCrossClientSkill, buildMcpEntry, mutateJsonFile } from "./base.js";
import { MCP_SERVER_NAME } from "../constants.js";

const VSCODE_MCP_CONFIG = join(homedir(), ".vscode", "mcp.json");

export const copilot: AgentConfigWriter = {
  id: "copilot",
  name: "GitHub Copilot",

  installSkill(global: boolean) {
    installCrossClientSkill(global);
  },

  installMcp() {
    // VS Code / Copilot uses "servers" not "mcpServers"
    mutateJsonFile(VSCODE_MCP_CONFIG, (config) => {
      if (!config.servers) config.servers = {};
      const entry = buildMcpEntry();
      config.servers[MCP_SERVER_NAME] = {
        command: entry.command,
        args: entry.args,
        env: entry.env,
      };
      return config;
    });
  },

  uninstallSkill() {
    removeCrossClientSkill(true);
  },

  uninstallMcp() {
    mutateJsonFile(VSCODE_MCP_CONFIG, (config) => {
      if (config.servers?.[MCP_SERVER_NAME]) {
        delete config.servers[MCP_SERVER_NAME];
      }
      return config;
    }, false);
  },
};
